import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NameSpace } from '../../const';
import { MainData } from '../../types/state';
import { FetchDataMainParams, FetchDataMainSuccessPayload, AddAnswerParams, AddQuestionnaireParams } from '../../types/request';
import { buildDataMain } from '../../utils/data-table';

const initialState: MainData = {
  data: null,
  fetchingStatusMainData: false
};

export const dataMainVPO = createSlice({
  name: NameSpace.DataMain,
  initialState,
  reducers: {
    fetchDataMainRequestVPO: (state, payload: PayloadAction<FetchDataMainParams>) => {
      state.fetchingStatusMainData = true;
    },
    fetchDataMainSuccessVPO: (state, action: PayloadAction<FetchDataMainSuccessPayload>) => {
      state.fetchingStatusMainData = false;
      const { data, params } = action.payload;
      console.log('mainDataResponse', data);
      state.data = buildDataMain(data, params.month, params.year);
    },
    createAnswerRequestVPO(state, payload: PayloadAction<AddAnswerParams>) {},
    createAnswerSuccessVPO: (state, action: PayloadAction<AddAnswerParams>) => {
      if (!state.data) return;

      const {
        id,
        Condition: answer,
        Subdivision: { title: departmentTitle },
        Requirement: { title: requirementTitle }
      } = action.payload.data[0];

      for (const block of state.data.data) {
        for (const process of block.groupRequirements) {
          for (const requirement of process.requirements) {
            if (requirement.title === requirementTitle) {
              for (const ans of requirement.answers) {
                if (ans.department === departmentTitle) {
                  ans.answerId = id;
                  ans.answer = answer;
                  ans.isEdit = true;
                  return;
                }
              }
            }
          }
        }
      }
    },
    updateAnswerRequestVPO(state, payload: PayloadAction<Pick<AddAnswerParams, 'Condition'>>) {},
    updateAnswerSuccessVPO: (state, action: PayloadAction<AddAnswerParams>) => {
      if (!state.data) return;

      const {
        Condition: answer,
        Subdivision: { title: departmentTitle },
        Requirement: { title: requirementTitle }
      } = action.payload.data;

      for (const block of state.data.data) {
        for (const process of block.groupRequirements) {
          for (const requirement of process.requirements) {
            if (requirement.title === requirementTitle) {
              for (const ans of requirement.answers) {
                if (ans.department === departmentTitle) {
                  ans.answer = answer;
                  return;
                }
              }
            }
          }
        }
      }
    },
    createQuestionnaireRequestVPO(state, payload: PayloadAction<AddQuestionnaireParams>) {},
    createQuestionnaireSuccessVPO: (state, action: PayloadAction<AddQuestionnaireParams>) => {
      if (!state.data) return;

      const { id, statusQuestionnaire } = action.payload.data;

      state.data.statusQuestionnaire = {
        id: id,
        title: statusQuestionnaire,
      };
    },
    updateQuestionnaireRequestVPO(state, payload: PayloadAction<AddQuestionnaireParams>) {},
    updateQuestionnaireSuccessVPO: (state, action: PayloadAction<Pick<AddQuestionnaireParams, 'statusQuestionnaire'>>) => {
      if (!state.data) return;

      const { id, statusQuestionnaire } = action.payload.data;

      state.data.statusQuestionnaire = {
        id: id,
        title: statusQuestionnaire,
      };
    },
    //! для смены иконки
    fetchActionsOnlyRequestVPO: (state, payload: PayloadAction<{ factory: number; month: number; year: string; column: number; group: number }>) => {},
    fetchActionsOnlySuccessVPO: (state, action: PayloadAction<{ actions: any[] }>) => {
      if (!state.data) return;
      const { actions } = action.payload;
      const actionPairs = new Set(
        actions.map((action) => `${action.requirement?.id}_${action.department?.id}`)
      );
      const newData = JSON.parse(JSON.stringify(state.data));
      let updatedCount = 0;
      newData.data.forEach((block: any) => {
        block.groupRequirements.forEach((group: any) => {
          group.requirements.forEach((requirement: any) => {
            requirement.answers.forEach((answer: any) => {
              const key = `${requirement.requirementId}_${answer.departmentId}`;
              const hasAction = actionPairs.has(key);
              // Обновляем только те ячейки, которые ЕСТЬ в ответе, остальные не трогаем
              if (hasAction && answer.actions !== ['Action']) {
                answer.actions = ['Action'];
                updatedCount++;
              }
            });
          });
        });
      });
      state.data = newData;
    },
    //! для переключения isAudit
    toggleAuditRequestVPO(state, payload: PayloadAction<{ answerId: number; isAudit: boolean }>) {},
    toggleAuditSuccessVPO: (state, action: PayloadAction<{ answerId: number; isAudit: boolean }>) => {
      if (!state.data) return;

      const { answerId, isAudit } = action.payload;

      for (const block of state.data.data) {
        for (const process of block.groupRequirements) {
          for (const requirement of process.requirements) {
            for (const ans of requirement.answers) {
              if (ans.answerId === answerId) {
                ans.isAudit = isAudit;
                return;
              }
            }
          }
        }
      }
    },
    //! Создание/обновление ответа с isAudit 
    createOrUpdateAuditRequestVPO(state, payload: PayloadAction<any>) {},
    createOrUpdateAuditSuccessVPO: (state, action: PayloadAction<any>) => {
      if (!state.data) return;

      const {
        id,
        Condition: answer,
        Subdivision: { title: departmentTitle },
        Requirement: { title: requirementTitle },
        isAudit
      } = action.payload.data;

      for (const block of state.data.data) {
        for (const process of block.groupRequirements) {
          for (const requirement of process.requirements) {
            if (requirement.title === requirementTitle) {
              for (const ans of requirement.answers) {
                if (ans.department === departmentTitle) {
                  ans.answerId = id;
                  ans.answer = answer;
                  ans.isAudit = isAudit;
                  return;
                }
              }
            }
          }
        }
      }
    },
  },
});

export const {
  fetchDataMainRequestVPO,
  fetchDataMainSuccessVPO,
  createAnswerRequestVPO,
  createAnswerSuccessVPO,
  updateAnswerRequestVPO,
  updateAnswerSuccessVPO,
  createQuestionnaireRequestVPO,
  createQuestionnaireSuccessVPO,
  updateQuestionnaireRequestVPO,
  updateQuestionnaireSuccessVPO,
  fetchActionsOnlyRequestVPO,
  fetchActionsOnlySuccessVPO,
  toggleAuditRequestVPO,
  toggleAuditSuccessVPO,
  createOrUpdateAuditRequestVPO,
  createOrUpdateAuditSuccessVPO
} = dataMainVPO.actions;
